import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Get all parents
        var getParents = function (elem, selector) {
            var parents = [];
            while (elem && elem !== document) {
                if (selector) {
                    if (elem.matches(selector)) {
                        parents.push(elem);
                    }
                } else {
                    parents.push(elem);
                }
                elem = elem.parentNode;
            }
            return parents;
        };

        // NAV CLASS CLEANING & ACTIVE
        Array.from(document.querySelectorAll('.c-nav-link')).forEach(a => {
            a.parentNode.classList.remove('is-active', '-is-ancestor', '-is-current')
        });
        if (location.pathname != '/') {
            Array.from(document.querySelectorAll('.c-nav-link')).forEach(a => {
                if (location.href === a.href) {
                    a.parentNode.classList.add('-is-current');
                    // Get all parents with .c-nav-li class
                    var navLi = getParents(a, '.c-nav-li');
                    if (navLi.length) {// If there's any
                        navLi.forEach(function (elm) {
                            //Add class ancestor
                            elm.classList.add('-is-ancestor');
                        });
                    }
                }
            });
        }

        let navWrapper = document.querySelector('.js-nav-overlay');
        let firstLvlLinks = document.querySelectorAll('.js-nav-overlay .is-lvl-1 .c-nav-overlay__item.has-children > .c-nav-overlay__link');
        let secondLvlLinks = document.querySelectorAll('.js-nav-overlay .is-lvl-2 .c-nav-overlay__item.has-children > .c-nav-overlay__link');

        let firstLevelPanel = document.querySelector('.is-lvl-1');

        let subnavsLvl2 = document.querySelectorAll('[data-navpanel="subnavs-lvl-2"] .c-nav-overlay');
        let subnavsLvl3 = document.querySelectorAll('[data-navpanel="subnavs-lvl-3"] .c-nav-overlay');

        let sidebarItem = document.querySelectorAll('.c-nav-sidebar__item');
        let currentIndex;
        let currentSubIndex;

        // Shift+tabbing from second to first lvl 
        Array.from(subnavsLvl2).forEach(function (subnav, index) {
            subnav.previousElm = firstLvlLinks[index];// get parent link
            subnav.subNavFirstLink = subnav.querySelector('li:first-child a'); // get first subnav link
            subnav.subNavLastLink = subnav.querySelector('li:last-child a'); // get last subnav link
            subnav.addEventListener('keydown', function (e) {
                let currentFocus = document.activeElement;
                // if tabing or shift tabing from first and last link, focus back on parent link, reset panel classes
                if (e.code === 'Tab' && e.shiftKey && subnav.subNavFirstLink === currentFocus || e.code === 'Tab' && e.shiftKey === false && subnav.subNavLastLink === currentFocus) {
                    e.preventDefault();
                    subnav.previousElm.focus();
                    classRemove(firstLevelPanel, 'has-panel-open');
                    classRemove(firstLvlLinks, 'has-child-active');
                    classRemove(subnavsLvl2, 'is-active-lvl-2');
                    classRemove(navWrapper, 'is-active-lvl-2');
                    classRemove(subnavsLvl3, 'is-active-lvl-3');
                    classRemove(navWrapper, 'is-active-lvl-3');
                }
            });
        });
        // Shift+tabbing from third to second lvl 
        Array.from(subnavsLvl3).forEach(function (subnav, index) {
            subnav.previousElm = secondLvlLinks[index];// get parent link
            subnav.subNavFirstLink = subnav.querySelector('li:first-child a'); // get first subnav link
            subnav.subNavLastLink = subnav.querySelector('li:last-child a'); // get last subnav link
            subnav.addEventListener('keydown', function (e) {
                let currentFocus = document.activeElement;
                // if tabing or shift tabing from first and last link, focus back on parent link, reset panel classes
                if (e.code === 'Tab' && e.shiftKey && subnav.subNavFirstLink === currentFocus || e.code === 'Tab' && e.shiftKey === false && subnav.subNavLastLink === currentFocus) {
                    e.preventDefault();
                    subnav.previousElm.focus();
                    classRemove(subnavsLvl3, 'is-active-lvl-3');
                    classRemove(navWrapper, 'is-active-lvl-3');
                }
            });
        });

        //add event on body that console log the current focus element
        // document.body.addEventListener('keydown', function(e) {
        //     if (e.code === 'Tab') {
        //         console.log(document.activeElement);
        //     }
        // });

        Array.from(firstLvlLinks).forEach(function (firstLvlLink, index) {
            // catch index of clicked link
            currentIndex = index;

            firstLvlLink.addEventListener('click', function (elm) {
                // Prevent click from first level panel links
                elm.preventDefault();

                // Transform translate first level panel to 'open' state
                firstLevelPanel.classList.add('has-panel-open');

                // Check if active link is reclicked
                if (!this.classList.contains('has-child-active')) {
                    // Close previous clicked link
                    classRemove(firstLvlLinks, 'has-child-active');
                    classRemove(secondLvlLinks, 'has-child-active');
                    classRemove(navWrapper, 'is-active-lvl-2');
                    classRemove(navWrapper, 'is-active-lvl-3');
                    classRemove(subnavsLvl2, 'is-active-lvl-2');
                    classRemove(subnavsLvl3, 'is-active-lvl-3');
                    classRemove(sidebarItem, 'is-active');

                    // Add 'active' state to clicked link
                    this.classList.add('has-child-active');
                    const activeSubnav = subnavsLvl2[index];
                    activeSubnav.classList.add('is-active-lvl-2');
                    classAdd(navWrapper, 'is-active-lvl-2');
                    classAdd(document.querySelector('html'),'has-nav-open');
                    
                    activeSubnav.querySelector('.c-nav-overlay__item:nth-child(2) .c-nav-overlay__link').focus();
                    console.log(activeSubnav.querySelector('.c-nav-overlay__item:nth-child(2) .c-nav-overlay__link'));

                } else {
                    // Back to default state
                    classRemove(firstLevelPanel, 'has-panel-open');
                    classRemove(firstLvlLinks, 'has-child-active');
                    classRemove(secondLvlLinks, 'has-child-active');
                    classRemove(subnavsLvl3, 'is-active-lvl-3');
                    classRemove(subnavsLvl2, 'is-active-lvl-2');
                    classRemove(navWrapper, 'is-active-lvl-3');
                    classRemove(navWrapper, 'is-active-lvl-2');
                    classRemove(sidebarItem, 'is-active');
                }
            });
        });

        Array.from(secondLvlLinks).forEach(function (secondLvlLink, index) {
            // catch index of clicked link
            currentIndex = index;
            currentSubIndex = index;

            secondLvlLink.addEventListener('click', function (elm) {
                // Prevent click from first level panel links
                elm.preventDefault();

                // Check if active link is reclicked
                if (!this.classList.contains('has-child-active')) {
                    // Close previous clicked link
                    classRemove(secondLvlLinks, 'has-child-active');
                    classRemove(subnavsLvl3, 'is-active-lvl-3');
                    classRemove(navWrapper, 'is-active-lvl-3');

                    // Add 'active' state to clicked link
                    this.classList.add('has-child-active');
                    const activeSubnav = subnavsLvl3[index];
                    activeSubnav.classList.add('is-active-lvl-3');
                    classAdd(navWrapper, 'is-active-lvl-3');
                    activeSubnav.querySelector('.c-nav-overlay__item:nth-child(2) .c-nav-overlay__link').focus();

                } else {
                    // Back to default state
                    classRemove(firstLevelPanel, 'has-panel-open');
                    classRemove(secondLvlLinks, 'has-child-active');
                    classRemove(subnavsLvl3, 'is-active-lvl-3');
                    classRemove(navWrapper, 'is-active-lvl-3');
                }
            });
        });

        // If click on close menu buttons
        let closeMenuBtns = document.querySelectorAll('.c-menu, .c-all-navs-overlay__close');
        Array.from(closeMenuBtns).forEach(function (closeMenuBtn, index) {
            closeMenuBtn.addEventListener('click', function () {
                // Back to default state
                //classRemove(document.querySelector('html'), 'has-nav-open');
                classRemove(firstLevelPanel, 'has-panel-open');
                classRemove(firstLvlLinks, 'has-child-active');
                classRemove(secondLvlLinks, 'has-child-active');
                classRemove(subnavsLvl2, 'is-active-lvl-2');
                classRemove(subnavsLvl3, 'is-active-lvl-3');
                classRemove(navWrapper, 'is-active-lvl-2');
                classRemove(navWrapper, 'is-active-lvl-3');
                document.activeElement.blur();
                document.querySelector('#page-content').focus();
            });
        });

        let menuBgClose = document.querySelector('.c-all-navs-overlay__close');
        menuBgClose.addEventListener('click', function () {
            classRemove(document.querySelector('html'), 'has-nav-open');
        });


        // Back lvl 2
        let backLvl2 = document.querySelectorAll('.is-lvl-2 .c-nav-overlay__back');
        Array.from(backLvl2).forEach(function (backButton) {
            backButton.addEventListener('click', function () {
                classRemove(subnavsLvl2, 'is-active-lvl-2');
                classRemove(navWrapper, 'is-active-lvl-2');
                classRemove(firstLvlLinks, 'has-child-active');
            });
        });
        // Back lvl 3
        let backLvl3 = document.querySelectorAll('.is-lvl-3 .c-nav-overlay__back');
        Array.from(backLvl3).forEach(function (backButton) {
            backButton.addEventListener('click', function () {
                classRemove(subnavsLvl3, 'is-active-lvl-3');
                classRemove(navWrapper, 'is-active-lvl-3');
            });
        });


    }
}
